import React, { Component } from "react";
import { withRouter } from "../../../utils/router";
import dayjs from "dayjs";

import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { formatCurrency } from "../../../utils/helpers";

class PrintGastos extends Component {
    state = {
        gastos: [],
        listo: false,
    };
    componentDidMount() {
        this.getGastos();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.listo && !prevState.listo) {
            window.print();
        }
    }
    getGastos = async () => {
        const response = await this.props.request(
            "gastos-generales" + window.location.search
        );

        if (response.data) {
            this.setState({
                gastos: response.data,
                listo: true,
            });
        }
    };
    render() {
        const { gastos } = this.state;
        const user = auth.getUser();
        const sucursal = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];

        const gastoTotal = gastos.reduce((acc, gasto) => {
            return acc + parseFloat(gasto.precio) * parseFloat(gasto.cantidad);
        }, 0);

        return (
            <div>
                <div className='row'>
                    <h2 className='col-md-12 text-center m-b-5'>Gastos</h2>
                    <div className='col-md-12 text-center'>
                        {sucursal.nombre} - {sucursal.direccion} •{" "}
                        {new Date().toLocaleString()}
                    </div>
                    <div className='col-md-12 text-right p-b-10'>
                        <div className='float-left'>
                            TOTAL GASTOS: {gastos.length}
                        </div>

                        <div className='float-right'>
                            <h3>TOTAL GASTOS: {formatCurrency(gastoTotal)}</h3>
                        </div>
                    </div>
                </div>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Categoría</th>
                            <th>Cuenta</th>
                            <th className='text-right'>Monto</th>
                            <th className='text-right'>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gastos.map((gasto) => {
                            return (
                                <tr key={gasto.id}>
                                    <td>
                                        {dayjs(gasto.fecha).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </td>
                                    <td>
                                        {gasto.item ? (
                                            <div style={{ lineHeight: 1.2 }}>
                                                <div>{gasto.item.nombre}</div>
                                                <small>
                                                    {gasto.descripcion}
                                                </small>
                                            </div>
                                        ) : (
                                            <div>{gasto.descripcion}</div>
                                        )}
                                    </td>
                                    <td>{gasto.cantidad}</td>
                                    <td>{gasto.categoria}</td>
                                    <td>{gasto.cuenta}</td>
                                    <td className='text-right'>
                                        {formatCurrency(gasto.precio)}
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(
                                            parseFloat(gasto.precio) *
                                                parseFloat(gasto.cantidad)
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='text-right'>
                                <strong>TOTAL:</strong>
                            </td>
                            <td className='text-right'>
                                <strong>{formatCurrency(gastoTotal)}</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRouter(withRequest(PrintGastos));
